import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

// eslint-disable-next-line
import 'antd/lib/icon/style/css';

import './styles.scss';

const ModalHeader = ({ iconType, children, backHandl }) => (
  <div className="modal-header">
    <button onClick={backHandl} className="header-back">
      <Icon type={iconType} style={{ fontSize: 20, color: '#004475' }} />
    </button>
    <p className="header-title">
      { children }
    </p>
  </div>
);

ModalHeader.defaultProps = {
  iconType: 'left'
};

ModalHeader.propTypes = {
  iconType: PropTypes.string,
  children: PropTypes.node.isRequired,
  backHandl: PropTypes.func.isRequired
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./src/components/ModalHeader/index.js